import { HolidayPayReportQueryController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows holiday pay report of selected holiday year
 * @example
 * ```html
 * <salaxy-holiday-pay-report-query></salaxy-holiday-pay-report-query>
 * ```
 */
export class HolidayPayReportQuery extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {};

    /** Uses the HolidayPayReportQueryController */
    public controller = HolidayPayReportQueryController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/HolidayPayReportQuery.html";

}
